<template>
  <section class="fixed-top">
    <nav class="navbar navbar-expand-lg">
      <div class="container">
        <a class="navbar-brand" href="#/home"><img :src="require('assets/images/logo.png')" alt="OpenCabana" /></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" @click.prevent="toggleNavbarMenu()">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">

          <div class="sidebar-menu-wrapper">
      <!-- <ul class="sidebar-menu icons">
        <li class="sidebar-menu-item" v-if="!isLoggedIn">
          <a href="" @click.prevent="openSidebarLink('login')"><i class="fa fa-sign-in"></i></a>
        </li>
        <li class="sidebar-menu-item" v-if="isLoggedIn">
          <a href="" @click.prevent="openSidebarLink('dashboard')"><i class="fa fa-user"></i><span>{{ userName }}</span></a>
        </li>
        <li class="sidebar-menu-item" v-if="isLoggedIn">
          <a href="" @click.prevent="logout"><i class="fa fa-sign-out"></i></a>
        </li>
      </ul> -->
      <!-- <li class="sidebar-menu-item">
        <a href="" @click.prevent="openSidebarLink('locations')">LOCATIONS</a>
      </li> -->
      <!-- <li class="sidebar-menu-item">
        <a href="" @click.prevent="openSidebarLink('hotel-partners')">Hotel Partners</a>
      </li> -->

      <ul class="sidebar-menu">
        <!-- <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('home')">HOME</a>
        </li> -->
        <!--
        <li class="sidebar-menu-item">
          <a href="#" @click.prevent="openSidebarLink('home')" v-scroll-to="'#features'">FEATURES & BENEFITS</a>
        </li>
        -->
        <!-- <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('home')">ACTIONABLE DATA</a>
        </li>
        <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('locations')">RESERVATION CALENDAR</a>
        </li> -->
        <!--
        <li class="sidebar-menu-item">
          <a href="#" @click.prevent="openSidebarLink('home')" v-scroll-to="'#contact_us'">CONTACT US</a>
          <!-- <a href="" @click.prevent="openSidebarLink('pages/contact')">CONTACT US</a>
        </li>
        -->
        <!--
        <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('pages/terms')">TERMS OF USE</a>
        </li>
        <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('pages/privacy')">PRIVACY</a>
        </li>
      -->
      </ul>

      <ul class="sidebar-menu">
        <li class="sidebar-menu-item">
          <el-button type="primary" round @click.prevent="openSidebarLink('locations')">BOOK A CABANA</el-button>
        </li>
      </ul>

      <div class="bottom-area text-center">
          <ul class="sidebar-menu">
            <li v-if="!isLoggedIn" class="sidebar-menu-item">
              <a href="" @click.prevent="openSidebarLink('login')">GUEST LOGIN</a>
            </li>
            <li v-if="isLoggedIn" class="sidebar-menu-item">
              <a href="" @click.prevent="logout" >LOGOUT</a>
            </li>
          </ul>
          <!-- <hr class="space xs" /> -->
          <div class="social-group">
              <a target="_blank" href="https://www.facebook.com/opencabana/"><i class="fa fa-facebook"></i></a>
              <a target="_blank" href="https://www.twitter.com/opencabana/"><i class="fa fa-twitter"></i></a>
              <a target="_blank" href="https://www.instagram.com/opencabana/"><i class="fa fa-instagram"></i></a>
              <a target="_blank" href="https://www.youtube.com/opencabana/"><i class="fa fa-youtube"></i></a>

          </div>
          <p>&copy; {{ date }} - All rights reserved.</p>
      </div>
    </div>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'Navbar',
  methods: {
    back() {
      this.$router.go(-1)
    },
    logout() {
      this.$store.dispatch('user/Logout').then(() => {
        this.$router.push('/home')
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      })
    }
  }
}
</script>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import moment from 'moment'
export default {
  data() {
    return {
      date: moment(new Date()).format('YYYY')
    }
  },
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters(['sidebar']),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    toggleNavbarMenu() {
      console.log('jkjk');
    },
    openSidebarLink(page) {
      $('#navbarSupportedContent').toggleClass('show')
      if (page === 'home') {
        this.$router.push('/home')
      } else {
        this.$router.push('/' + page)
      }
    },
    logout() {
      this.$store.dispatch('user/Logout').then(() => {
        this.$router.push('/home')
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Navbar.vue?c833c3ae